{{each data}}
<li>
	{{if $value.cover}}
    <a href="/org/article?id={{$value.id}}" class="article-img"><img src="{{$value.cover}}" alt=""></a>
    {{/if}}
    <div class="article-detail">
        <p><a href="/article/detail?id={{$value.id}}">{{$value.title}}</a></p>
        <span>{{$value.create_time}}</span>
    </div>
</li>
{{/each}}
